<template>
	<modal
		v-model="isOpen"
		width="650px"
		:title="dialogTitle"
		:cancel-text="$t('dont-ask-again')"
		:confirm-text="$t('connect-page')"
		:cancel-loading="isDisconnecting"
		@cancel="cancel"
		@confirm="confirm"
	>
		<v-card-text class="px-4 pt-0 text-subtitle-1 pb-16">
			<div class="pb-2">
				<span>{{ $t("email-colon") }}</span>
				<span class="font-weight-bold">{{ email }}</span>
			</div>
			<div>
				{{ dialogContent }}
			</div>
		</v-card-text>
	</modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import { disconnectEmailProvider } from "@/composables/mail";
import { PROVIDER_NAME_MAP } from "@/common/const";
import { mapActions, mapGetters } from "vuex";

export default {
	name: "EmailDisconnectedDialog",
	components: { Modal },

	data() {
		return {
			isOpen: false,
			isDialogHasBeenShown: false,
			checkedEmails: {},
			isDisconnecting: false
		};
	},

	computed: {
		...mapGetters("login", ["connected", "userGroup"]),

		dialogContent() {
			return this.$t("connection-expired");
		},

		email() {
			return this.userGroup?.email;

		},

		dialogTitle() {
			const provider = PROVIDER_NAME_MAP[this.userGroup?.emailProvider];

			return this.$t("reconnect-provider", { provider });
		}
	},

	watch: {
		userGroup() {
			const isThisEmailChecked = this.checkedEmails[this.userGroup?.email];

			if (this.userGroup?.emailProvider && this.userGroup?.emailProvider !== "unknown" && !this.userGroup?.valid && !isThisEmailChecked) {
				this.isOpen = true;
				this.checkedEmails[this.userGroup?.email] = true;
			}
		},

		connected() {
			if (!this.connected) {
				this.checkedEmails = {};
			}
		}
	},

	methods: {
		...mapActions("login", ["assignUserGroupEmail"]),

		async cancel(payload) {
			if (payload?.isClosing) {
				this.isDialogHasBeenShown = true;
			} else if (this.userGroup?.email) {
				try {
					this.isDisconnecting = true;
					await disconnectEmailProvider(this.userGroup?.email);

					this.assignUserGroupEmail({
						email: this.userGroup.email,
						emailProvider: null,
						valid: null
					});
				} catch (err) {
					this.$error(this.$t("error.logout"));
				} finally {
					this.isDisconnecting = false;
				}
			}
			this.isOpen = false;
		},

		confirm() {
			this.$router.push("/configuration?configTab=2&tab=1");
			this.isOpen = false;
		}
	}
};
</script>

